import { Skeleton, SkeletonProps } from '@mui/joy';

export const RectangleSkeleton = ({
  width,
  height = '20px',
  flex,
  sx,
  ...props
}: Omit<SkeletonProps, 'variant'> & { flex?: number }) => {
  return (
    <Skeleton
      variant='rectangular'
      width={width}
      height={height}
      sx={{ borderRadius: '8px', flex, ...sx }}
      {...props}
    />
  );
};
